/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WalletCouponHalResponse } from '../../models/wallet-coupon-hal-response';

export interface GetCouponById$Params {
  'Active-Tenant-Identifier': string;
  couponId: string;
}

export function getCouponById(http: HttpClient, rootUrl: string, params: GetCouponById$Params, context?: HttpContext): Observable<StrictHttpResponse<WalletCouponHalResponse>> {
  const rb = new RequestBuilder(rootUrl, getCouponById.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('couponId', params.couponId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WalletCouponHalResponse>;
    })
  );
}

getCouponById.PATH = '/wallet/coupons/{couponId}';
